import { AxiosResponse } from 'axios';

import { prepareFiltersOfSelection, prepareQPFromFilters, serverAxios } from 'utils/http';
import {
  IGetExtraServicesResponse,
  ICreateExtraServicesResponse,
  ICreateExtraServicesRequest,
  IUpdateExtraServicesResponse,
  IUpdateExtraServicesRequest,
  IGetSingleExtraServiceResponse,
  IDeleteExtraServicesResponse,
  IDeleteExtraServicesFilters,
  IGetExtraServicesFilters,
} from 'models/http/extraServices';
import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';
import { HTTP } from './core.http';
import { DataUploadModels, ModelsNames } from 'utils/enums/model-names';
import DataUploadBaseHttp from './utils/data-upload.http';
import { IGetSimpleListFilters, IGetSimpleListResponse } from 'models/http/common';

class ExtraServicesHttp extends DataUploadBaseHttp implements HTTP<IDeleteExtraServicesFilters> {
  protected readonly route: DataUploadModels = ModelsNames.ExtraService;

  public async getSimple(_?: IGetSimpleListFilters, abortController?: AbortController): Promise<IGetSimpleListResponse> {
    return serverAxios
      .get(`/${this.route}/simple`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetSimpleListResponse>) => {
        return response.data;
      });
  }

  public async getById(id: string, abortController?: AbortController): Promise<IGetSingleExtraServiceResponse> {
    return serverAxios
      .get(`/${this.route}/single/${id}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetSingleExtraServiceResponse>) => {
        return response.data;
      });
  }

  public async get(filters?: IGetExtraServicesFilters, abortController?: AbortController): Promise<IGetExtraServicesResponse> {
    const queryParams = prepareQPFromFilters(filters || {});

    return serverAxios
      .get(`/${this.route}?${queryParams.toString()}`, {
        timeout: HttpTimeoutPriority.Medium,
        signal: abortController?.signal,
      })
      .then((response: AxiosResponse<IGetExtraServicesResponse>) => {
        return response.data;
      });
  }

  public async create(data: ICreateExtraServicesRequest): Promise<ICreateExtraServicesResponse> {
    return serverAxios
      .post(`/${this.route}`, data, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<ICreateExtraServicesResponse>) => {
        return response.data;
      });
  }

  public async update(id: number, data: IUpdateExtraServicesRequest): Promise<IUpdateExtraServicesResponse> {
    return serverAxios
      .put(`/${this.route}/${id}`, data, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IUpdateExtraServicesResponse>) => {
        return response.data;
      });
  }

  public async delete(ids: number[]): Promise<IDeleteExtraServicesResponse>;
  public async delete(filters: IDeleteExtraServicesFilters): Promise<IDeleteExtraServicesResponse>;
  public async delete(filters: number[] | IDeleteExtraServicesFilters): Promise<IDeleteExtraServicesResponse> {
    return serverAxios
      .delete(`/${this.route}`, {
        data: prepareFiltersOfSelection(filters),
      })
      .then((response: AxiosResponse<IDeleteExtraServicesResponse>) => {
        return response.data;
      });
  }
}

export default ExtraServicesHttp;
